import { BodySmall } from 'components/Typography';
import styled from 'styled-components/macro';

export const ShareText = styled(BodySmall)<{ $color?: string }>`
  color: ${({ theme, $color }) => $color || theme.colors.white};
  margin-left: 8px;
  text-decoration: underline;
`;
